const services = document.querySelectorAll('.store-services li');

for (const service of services) {
  service.addEventListener('click', function (e) {
    const content = service.querySelector('.store-services__content');
    const plusIcon = service.querySelector('.store-services__plus');
    const minusIcon = service.querySelector('.store-services__minus');

    if (content) {
      content.classList.toggle('hidden');
      if (plusIcon) plusIcon.classList.toggle('hidden');
      if (minusIcon) minusIcon.classList.toggle('hidden');
    }
  });
}
